import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { PrimaryButton } from '../../../shared/ui';

type ReferralBonusInviteButtonProps = {
  disabled?: boolean;
  feedbackText?: string | null;
  onInvite?: () => void;
};

const InviteBlock = styled.div.attrs({
  'data-ui': 'referral-bonus-invite-button-block',
})`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(8)};
`;

const Button = styled(PrimaryButton).attrs({
  'data-ui': 'referral-bonus-invite-button',
})`
  width: 100%;
  min-height: ${({ theme }) => theme.scale.px(56)};
  border-radius: ${({ theme }) => theme.scale.px(10)};
  font-size: ${({ theme }) => theme.scale.px(15)};
  line-height: ${({ theme }) => theme.scale.px(19)};
`;

const Feedback = styled.p.attrs({
  'aria-live': 'polite',
  role: 'status',
})`
  min-height: ${({ theme }) => theme.scale.px(18)};
  margin: 0;
  text-align: center;
  font-size: ${({ theme }) => theme.scale.px(12)};
  line-height: ${({ theme }) => theme.scale.px(18)};
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export function ReferralBonusInviteButton({
  disabled = false,
  feedbackText = null,
  onInvite,
}: ReferralBonusInviteButtonProps) {
  const { t } = useTranslation();

  return (
    <InviteBlock>
      <Button type="button" onClick={onInvite} disabled={disabled}>
        {t('referralBonus.heroCta')}
      </Button>
      <Feedback>{feedbackText ?? ''}</Feedback>
    </InviteBlock>
  );
}
